<template>
    <v-container fluid class="pa-5">

        <v-row align="center" justify="center">
            <v-col cols="12" sm="10" md="10" lg="8" xl="6">
                <v-card :class="classVCard()" elevation="0">
                    <v-list-item three-line>
                        <v-list-item-content>
                            <v-list-item-title class="text-h5 mb-1">
                                {{ $t("lookbook.download") }}
                            </v-list-item-title>

                            <span v-html="$t('lookbook.downloadCollezione')"></span>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
            </v-col>

        </v-row>
        <v-row align="center" justify="center" class="mt-10">
            <v-col cols="auto">
                <v-btn outlined href="lookbook2024.pdf" download>
                    {{ $t("lookbook.download") }} <v-icon>mdi-download</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="auto">
                <v-btn outlined href="https://positano-couture.myshopify.com/" target="_blank">
                    {{ $t('lookbook.visitShop') }}
                </v-btn>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>

export default {
    name: "Lookbook6",
    components: {},

    data() {
        return {
        };
    },

    methods: {
        isMobile() {
            return this.$vuetify.breakpoint.name === "xs";
        },
        classVCard() {
            if (this.isMobile()) {
                return "px-4 mt-10";
            } else {
                return "px-4";
            }
        },
    }
}
</script>

<style scoped></style>
